import { render, staticRenderFns } from "./OrdersListBoxesStatus.vue?vue&type=template&id=753b2985&scoped=true&"
import script from "./OrdersListBoxesStatus.vue?vue&type=script&lang=js&"
export * from "./OrdersListBoxesStatus.vue?vue&type=script&lang=js&"
import style0 from "./OrdersListBoxesStatus.vue?vue&type=style&index=0&id=753b2985&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753b2985",
  null
  
)

export default component.exports